import { inlineMediaQueryMixin } from './inlineMediaQueryMixin';
import { spaceMixin } from './spaceMixin';

/** @mixin paddingMixin */
/**
 * Adds padding props.
 *
 * <ul>
 *     <li><code>padding</code></li>
 *     <li><code>paddingX</code></li>
 *     <li><code>paddingY</code></li>
 *     <li><code>paddingTop</code></li>
 *     <li><code>paddingBottom</code></li>
 *     <li><code>paddingLeft</code></li>
 *     <li><code>paddingRight</code></li>
 * </ul>
 *
 * @example
 * import { paddingMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${paddingMixin}
 * `;
 *
 * <Component padding="xl" paddingTop="lg" paddingX="md" />
 * <Component padding={{ default: 'sm', md: 'lg' }} />
 *
 * @method
 * @param {object} props
 * @param {object} props.theme - The styled-components theme object.
 * @return {CSSObject}
 */
export var paddingMixin = function paddingMixin(props) {
  var styles = [];
  if ('padding' in props) {
    styles.push(inlineMediaQueryMixin('padding', function (mediaProps) {
      return "padding: " + spaceMixin(mediaProps.padding)(mediaProps) + ";";
    })(props));
  }
  if ('paddingX' in props) {
    styles.push(inlineMediaQueryMixin('paddingX', function (mediaProps) {
      return "\n                    padding-left: " + spaceMixin(mediaProps.paddingX)(mediaProps) + ";\n                    padding-right: " + spaceMixin(mediaProps.paddingX)(mediaProps) + ";\n                ";
    })(props));
  }
  if ('paddingY' in props) {
    styles.push(inlineMediaQueryMixin('paddingY', function (mediaProps) {
      return "\n                    padding-top: " + spaceMixin(mediaProps.paddingY)(mediaProps) + ";\n                    padding-bottom: " + spaceMixin(mediaProps.paddingY)(mediaProps) + ";\n                ";
    })(props));
  }
  if ('paddingTop' in props) {
    styles.push(inlineMediaQueryMixin('paddingTop', function (mediaProps) {
      return "padding-top: " + spaceMixin(mediaProps.paddingTop)(mediaProps) + ";";
    })(props));
  }
  if ('paddingBottom' in props) {
    styles.push(inlineMediaQueryMixin('paddingBottom', function (mediaProps) {
      return "padding-bottom: " + spaceMixin(mediaProps.paddingBottom)(mediaProps) + ";";
    })(props));
  }
  if ('paddingLeft' in props) {
    styles.push(inlineMediaQueryMixin('paddingLeft', function (mediaProps) {
      return "padding-left: " + spaceMixin(mediaProps.paddingLeft)(mediaProps) + ";";
    })(props));
  }
  if ('paddingRight' in props) {
    styles.push(inlineMediaQueryMixin('paddingRight', function (mediaProps) {
      return "padding-right: " + spaceMixin(mediaProps.paddingRight)(mediaProps) + ";";
    })(props));
  }
  return styles;
};